import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=34932302"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34932302')) {
      api.createRecord('34932302', component.options)
    } else {
      api.reload('34932302', component.options)
    }
    module.hot.accept("./RoleForm.vue?vue&type=template&id=34932302", function () {
      api.rerender('34932302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/role/RoleForm.vue"
export default component.exports